export enum LanguageTags {
  Russian = 'ru',
  Polish = 'pl',
  English = 'en',
}
